import { Divider, Stack, Typography } from "@mui/material";
import { ArrowUpRight, ChartBar } from "@phosphor-icons/react";
import { Button } from "components/UI";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";
import { useDenominationStore } from "../store";
import { GenerateReportFormModal } from "./GenerateReportFormModal";

export const DenominationReports = () => {
  const [isGenerateReportOpen, setIsGenerateReportOpen] = useState(false);

  const setHeaderTitle = useCentralStore(state => state.setHeaderTitle);
  const selectedDenomination = useDenominationStore(
    state => state.selectedDenomination
  );
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setHeaderTitle(t("denominations.reports.churchPerformanceReport"));

    return () => {
      setHeaderTitle("");
    };
  }, []);

  return (
    <Stack py={3} spacing={5}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={1}
      >
        {/* <Button
          onClick={() =>
            navigate(`/denomination-dashboard/${id}/reports/summary`)
          }
        >
          Go to report summary
        </Button> */}
        <Button onClick={() => setIsGenerateReportOpen(true)}>
          {t("denominations.reports.generateReportForm")}
        </Button>
        {/* <Button>Export Report</Button> */}
        {/* <Button flavor="outlined" endIcon={<Calendar />}>
          Filter by date
        </Button> */}
      </Stack>

      <Stack>
        <Typography variant="h6" fontWeight={700}>
          {t("denominations.reports.reports")}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Stack
          sx={{
            borderRadius: "20px",
            backgroundColor: "#4e5ba6",
            color: "#fff",
            padding: "16px",
            width: "400px",
            height: "200px"
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              ml: "auto",
              bgcolor: "#fff",
              borderRadius: "50px",
              height: "40px",
              width: "40px"
            }}
          >
            <ChartBar size={24} color="#4e5ba6" />
          </Stack>
          <Typography variant="h6" fontWeight={900} mt="auto" mb={1}>
            {t("denominations.reports.churchPerformanceReport")}
          </Typography>
          <Divider sx={{ bgcolor: "rgba(255, 255, 255, 0.25)" }} />
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            mt={1}
            sx={{ cursor: "pointer" }}
          >
            <ArrowUpRight />
            <Typography
              variant="body2"
              onClick={() =>
                navigate(
                  `/denomination-dashboard/${selectedDenomination?.id}/reports/performance`
                )
              }
            >
              {t("demoninations.dashbord.clickToView")}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <GenerateReportFormModal
        open={isGenerateReportOpen}
        onClose={() => setIsGenerateReportOpen(false)}
      />
    </Stack>
  );
};
